/**
 * Identita buildu. Placeholdery `...` nahradi `git archive`
 * (export-subst v .gitattributes) pri nasazeni na PP3. Lokalne zustanou
 * nahradene a getBuildInfo() je prevede na "local".
 */
const GIT_PLACEHOLDER = 'c15ec11';
const DATE_PLACEHOLDER = '2026-11-03';

/** Drzet v souladu s root package.json. Patch +1 pri kazdem nasazeni na Fordigi. */
export const APP_VERSION = '0.1.11';

export interface BuildInfo {
  version: string;
  git: string;
  built: string;
}

function resolveSubst(value: string): string {
  return value.includes('$Format:') ? '' : value;
}

export function getBuildInfo(): BuildInfo {
  return {
    version: APP_VERSION,
    git: resolveSubst(GIT_PLACEHOLDER) || 'local',
    built: resolveSubst(DATE_PLACEHOLDER),
  };
}
